import { invoicesAPI } from '../lib/api';
import { getCurrentCompanyId } from '../utils/auth';

// Mock data fallback for when API calls fail
const mockInvoices = [
  {
    id: '1',
    invoiceNumber: 'INV-2026-001',
    customerName: 'Tech Solutions Inc.',
    customerEmail: 'john@techsolutions.com',
    amount: 5500.00,
    paidAmount: 0.00,
    issueDate: '2026-01-15',
    dueDate: '2026-02-14',
    status: 'Sent'
  },
  {
    id: '2',
    invoiceNumber: 'INV-2026-002',
    customerName: 'Marketing Masters LLC',
    customerEmail: 'sarah@marketingmasters.com',
    amount: 3200.00,
    paidAmount: 3200.00,
    issueDate: '2026-01-10',
    dueDate: '2026-01-25',
    status: 'Paid'
  }
];

export const getInvoices = async (companyId = null) => {
  try {
    const actualCompanyId = companyId || getCurrentCompanyId();
    if (!actualCompanyId) {
      console.warn('No company ID available, returning empty invoices');
      return [];
    }
    
    const response = await invoicesAPI.getAll(actualCompanyId);
    console.log('Invoice service - Raw API response:', response.data);
    
    // Handle the specific API response format: { Success: true, Data: [...] }
    let invoices = [];
    if (response.data) {
      if (response.data.Success && Array.isArray(response.data.Data)) {
        invoices = response.data.Data;
      } else if (Array.isArray(response.data)) {
        invoices = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        invoices = response.data.data;
      } else if (response.data.success && Array.isArray(response.data.result)) {
        invoices = response.data.result;
      } else {
        console.warn('Unexpected API response format:', response.data);
        invoices = [];
      }
    }
    
    console.log('Invoice service - Processed invoices:', invoices);
    return invoices;
  } catch (error) {
    console.error('Error in getInvoices:', error);
    // Return empty array instead of mock data for new companies
    return [];
  }
};

export const createInvoice = async (invoiceData) => {
  try {
    const response = await invoicesAPI.create(invoiceData);
    return response.data;
  } catch (error) {
    console.error('Error creating invoice:', error);
    throw error;
  }
};

export const updateInvoice = async (id, invoiceData) => {
  try {
    const response = await invoicesAPI.update(id, invoiceData);
    return response.data;
  } catch (error) {
    console.error('Error updating invoice:', error);
    throw error;
  }
};

export const deleteInvoice = async (id) => {
  try {
    await invoicesAPI.delete(id);
    return true;
  } catch (error) {
    console.error('Error deleting invoice:', error);
    throw error;
  }
};